export default __webpack_public_path__ + "static/hadawa_video-309d0489fea0ab1fe5d7b54ae06ef115.mp4";